import BasicLayout from '@/layouts/Basic';
import {wrapModelLoaderAsBeforeRouterEnterHook} from '../lib/model';

const importEnv = require('./_import_' + process.env.NODE_ENV);

export default [
    {
        path: '/textCreate',
        name: 'textCreateWork',
        component: BasicLayout,
        children: [
            {
                path: '/',
                redirect: {
                    name: 'textCreateWork'
                }
            },
            {
                path: 'work',
                name: 'textCreateWork',
                meta: {
                    authorizedRole: 'digital_human_list'
                },
                component: importEnv('TextCreate/work/index')
            },
            {
                path: 'title/fc',
                name: 'textCreateFc',
                meta: {
                    source: 'fc',
                    authorizedRole: 'digital_human_list'
                },
                beforeEnter: wrapModelLoaderAsBeforeRouterEnterHook('TextCreate', () =>
                    import('../model/TextCreate')
                ),
                component: importEnv('TextCreate/create/AiContent')
            },
            {
                path: 'title/feed',
                name: 'textCreateFeed',
                meta: {
                    source: 'feed',
                    authorizedRole: 'digital_human_list'
                },
                beforeEnter: wrapModelLoaderAsBeforeRouterEnterHook('TextCreate', () =>
                    import('../model/TextCreate')
                ),
                component: importEnv('TextCreate/create/AiContent')
            },
            {
                path: 'script',
                name: 'textCreateScript',
                meta: {
                    source: 'script',
                    authorizedRole: 'digital_human_list'
                },
                beforeEnter: wrapModelLoaderAsBeforeRouterEnterHook('TextCreate', () =>
                    import('../model/TextCreate')
                ),
                component: importEnv('TextCreate/create/AiContent')
            }
        ]
    }
];